const DEV_BUILD =
  typeof import.meta !== 'undefined' && !!(import.meta.env && import.meta.env.DEV === true)

function readWindowFlag(flagName) {
  try {
    if (typeof window === 'undefined' || !flagName) return false
    return window[flagName] === true
  } catch {
    return false
  }
}

export function isDebugLogEnabled(scope = 'avatarChat') {
  if (DEV_BUILD) return true
  if (readWindowFlag('__AVATAR_CHAT_DEBUG__')) return true
  if (scope === 'avatar' && readWindowFlag('DEBUG_AVATAR')) return true
  if (scope === 'sfu' && readWindowFlag('__SFU_DEBUG__')) return true
  return false
}

export function createDebugLogger(scope = 'avatarChat') {
  return (...args) => {
    if (!isDebugLogEnabled(scope)) return
    try {
      console.debug(...args)
    } catch {}
  }
}
